/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddProductReviewCommentDto } from '../../models/add-product-review-comment-dto';
import { ProductReviewDto } from '../../models/product-review-dto';

export interface AddComment$Params {
  id: string;
      body: AddProductReviewCommentDto
}

export function addComment(http: HttpClient, rootUrl: string, params: AddComment$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductReviewDto>> {
  const rb = new RequestBuilder(rootUrl, addComment.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductReviewDto>;
    })
  );
}

addComment.PATH = '/api/v1/product-reviews/{id}/comment';
